(function () {
  'use strict';

  const PRESERVED_PARAM_PREFIXES = ['filter.'];
  const PRESERVED_PARAM_KEYS = ['sort_by'];
  // Tryb filtrowania: parametr facetu tagów (wartości = grupy tagów z Search & Discovery)
  const TAG_FILTER_PARAM = 'filter.p.tag';
  // Formularze facetów serializowane przez FacetFiltersForm (FormData) — aktywny tag
  // musi w nich istnieć jako hidden input, inaczej zmiana innego filtra go skasuje.
  const FACET_FORM_IDS = ['FacetFiltersForm', 'FacetFiltersFormMobile'];

  function preservedSearchParams(searchString) {
    const src = new URLSearchParams(searchString || window.location.search);
    const out = new URLSearchParams();
    src.forEach((value, key) => {
      if (PRESERVED_PARAM_KEYS.includes(key)) {
        out.append(key, value);
        return;
      }
      if (PRESERVED_PARAM_PREFIXES.some((p) => key.startsWith(p))) {
        out.append(key, value);
      }
    });
    return out;
  }

  function normalizePath(path) {
    if (!path) return '';
    return path.replace(/\/+$/, '');
  }

  function findGridSectionId() {
    const node = document.querySelector('#ProductGridContainer [data-id], #ProductGridContainer .collection[data-id]');
    return node ? node.getAttribute('data-id') : null;
  }

  class NaokoSubCollectionFilter {
    constructor(root) {
      this.root = root;
      this.parentUrl = root.dataset.parentCollectionUrl;
      this.parentHandle = root.dataset.parentCollectionHandle;
      this.isFilterMode = root.dataset.filterMode === 'true';
      this.buttons = Array.from(root.querySelectorAll('.sub-collection-filter__btn'));
      this.list = root.querySelector('.sub-collection-filter__list');
      this.prevArrow = root.querySelector('.sub-collection-filter__arrow--prev');
      this.nextArrow = root.querySelector('.sub-collection-filter__arrow--next');
      this.isLoading = false;

      this.onClick = this.onClick.bind(this);
      this.onPopState = this.onPopState.bind(this);
      this.onArrowClick = this.onArrowClick.bind(this);
      this.updateArrows = this.updateArrows.bind(this);

      this.root.addEventListener('click', this.onClick);
      window.addEventListener('popstate', this.onPopState);

      if (this.list && (this.prevArrow || this.nextArrow)) {
        this.prevArrow && this.prevArrow.addEventListener('click', this.onArrowClick);
        this.nextArrow && this.nextArrow.addEventListener('click', this.onArrowClick);
        this.list.addEventListener('scroll', this.updateArrows, { passive: true });
        window.addEventListener('resize', this.updateArrows);
        this.updateArrows();
      }

      if (this.isFilterMode) {
        // Deep link z ?filter.p.tag=... — od razu odzwierciedl go w formularzach facetów
        // i na przyciskach. SSR nie wystarcza: przy >100 wartościach facetu tagów Shopify
        // filtruje, ale nie raportuje wartości w collection.filters[].active_values.
        this.syncFacetHiddenInputs();
        this.syncActiveFromUrl();
        // FacetFiltersForm zmienia URL przez pushState (bez popstate) przy każdej
        // interakcji z facetami (w tym „wyczyść wszystko"). Grid jest wtedy
        // podmieniany, więc nasłuch na jego re-render to jedyny wspólny sygnał
        // do resynchronizacji stanu przycisków i hidden inputów.
        const grid = document.getElementById('ProductGridContainer');
        if (grid) {
          this.gridObserver = new MutationObserver(() => {
            this.syncActiveFromUrl();
            this.syncFacetHiddenInputs();
          });
          this.gridObserver.observe(grid, { childList: true });
        }
      }
    }

    onArrowClick(event) {
      if (!this.list) return;
      const dir = event.currentTarget === this.prevArrow ? -1 : 1;
      const step = this.list.clientWidth * 0.8;
      this.list.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.list) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.list;
      const overflowing = scrollWidth > clientWidth + 1;
      const atStart = scrollLeft <= 1;
      const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;
      if (this.prevArrow) this.prevArrow.hidden = !overflowing || atStart;
      if (this.nextArrow) this.nextArrow.hidden = !overflowing || atEnd;
    }

    onClick(event) {
      const btn = event.target.closest('.sub-collection-filter__btn');
      if (!btn || !this.root.contains(btn)) return;
      event.preventDefault();
      if (this.isLoading) return;

      if (this.isFilterMode) {
        this.toggleFilterTag(btn);
        return;
      }

      if (btn.classList.contains('is-active')) {
        this.navigate(this.parentUrl, null);
      } else {
        this.navigate(btn.dataset.collectionUrl, btn.dataset.collectionHandle);
      }
    }

    toggleFilterTag(btn) {
      const value = btn.dataset.filterValue;
      const wasActive = btn.classList.contains('is-active');

      const params = preservedSearchParams();
      params.delete(TAG_FILTER_PARAM);
      if (!wasActive) params.append(TAG_FILTER_PARAM, value);

      const search = params.toString();
      const browserUrl = search ? `${this.parentUrl}?${search}` : this.parentUrl;

      this.setActive(wasActive ? null : btn.dataset.collectionHandle);
      history.pushState({ naokoSubCollection: null, searchParams: search }, '', browserUrl);
      this.syncFacetHiddenInputs();
      this.fetchAndSwap(this.parentUrl);
    }

    // Utrzymuje hidden input z aktywnym filter.p.tag w formularzach facetów, żeby
    // FacetFiltersForm (serializacja FormData) nie gubił filtra subkolekcji przy
    // zmianie rozmiaru/koloru/ceny. Wartość czytana z URL-a = jedno źródło prawdy.
    syncFacetHiddenInputs() {
      const value = new URLSearchParams(window.location.search).get(TAG_FILTER_PARAM);
      FACET_FORM_IDS.forEach((id) => {
        const form = document.getElementById(id);
        if (!form) return;
        let input = form.querySelector('input[data-naoko-subcollection-tag]');
        if (value) {
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = TAG_FILTER_PARAM;
            input.setAttribute('data-naoko-subcollection-tag', '');
            form.prepend(input);
          }
          input.value = value;
        } else if (input) {
          input.remove();
        }
      });
    }

    onPopState() {
      this.syncActiveFromUrl();

      if (this.isFilterMode) {
        this.syncFacetHiddenInputs();
        // Grid odtworzy popstate handler FacetFiltersForm (ten sam pathname, inne
        // parametry); refetch tylko gdy facetów nie ma na stronie.
        if (!(window.FacetFiltersForm && typeof FacetFiltersForm.renderProductGridContainer === 'function')) {
          this.fetchAndSwap(this.parentUrl, false);
        }
        return;
      }

      // Sekcja gridu zostanie podmieniona przez FacetFiltersForm jego własnym popstate handlerem,
      // jeśli zmiana dotyczy filtrów. Dla zmiany samej kolekcji wymuszamy refetch.
      const currentPath = normalizePath(window.location.pathname);
      const matchedBtn = this.buttons.find(
        (b) => normalizePath(new URL(b.dataset.collectionUrl, window.location.origin).pathname) === currentPath
      );
      const targetUrl = matchedBtn ? matchedBtn.dataset.collectionUrl : this.parentUrl;
      this.fetchAndSwap(targetUrl, false);
    }

    setActive(handle) {
      this.buttons.forEach((b) => {
        const active = handle && b.dataset.collectionHandle === handle;
        b.classList.toggle('is-active', !!active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    syncActiveFromUrl() {
      if (this.isFilterMode) {
        const value = new URLSearchParams(window.location.search).get(TAG_FILTER_PARAM);
        const matched = value ? this.buttons.find((b) => b.dataset.filterValue === value) : null;
        this.setActive(matched ? matched.dataset.collectionHandle : null);
        return;
      }

      const currentPath = normalizePath(window.location.pathname);
      const matched = this.buttons.find(
        (b) => normalizePath(new URL(b.dataset.collectionUrl, window.location.origin).pathname) === currentPath
      );
      this.setActive(matched ? matched.dataset.collectionHandle : null);
    }

    navigate(targetUrl, handle) {
      this.setActive(handle);

      const preserved = preservedSearchParams();
      const search = preserved.toString();
      const browserUrl = search ? `${targetUrl}?${search}` : targetUrl;

      history.pushState({ naokoSubCollection: handle || null, searchParams: search }, '', browserUrl);

      this.fetchAndSwap(targetUrl, true);
    }

    fetchAndSwap(targetUrl) {
      const sectionId = findGridSectionId();
      if (!sectionId) {
        window.location.assign(window.location.href);
        return;
      }

      const container = document.getElementById('ProductGridContainer');
      const preserved = preservedSearchParams();
      const qp = new URLSearchParams(preserved);
      qp.set('section_id', sectionId);
      const fetchUrl = `${targetUrl}?${qp.toString()}`;

      this.isLoading = true;
      if (container) container.classList.add('loading');
      this.root.classList.add('is-loading');

      fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then((r) => {
          if (!r.ok) throw new Error('Section render failed: ' + r.status);
          return r.text();
        })
        .then((html) => {
          if (window.FacetFiltersForm && typeof FacetFiltersForm.renderProductGridContainer === 'function') {
            FacetFiltersForm.renderProductGridContainer(html);
            if (typeof FacetFiltersForm.renderProductCount === 'function') {
              FacetFiltersForm.renderProductCount(html);
            }
            if (typeof FacetFiltersForm.renderProductPerPage === 'function') {
              FacetFiltersForm.renderProductPerPage();
            }
          } else {
            this.fallbackSwap(html);
          }
          document.dispatchEvent(
            new CustomEvent('naoko:sub-collection-filter:changed', { bubbles: true })
          );
        })
        .catch((err) => {
          console.error('[sub-collection-filter]', err);
        })
        .finally(() => {
          this.isLoading = false;
          if (container) container.classList.remove('loading');
          this.root.classList.remove('is-loading');
        });
    }

    fallbackSwap(html) {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const incoming = parsed.querySelector('#ProductGridContainer');
      const current = document.getElementById('ProductGridContainer');
      if (incoming && current) current.innerHTML = incoming.innerHTML;
    }
  }

  function init() {
    document.querySelectorAll('[data-sub-collection-filter]').forEach((root) => {
      if (root.__naokoSubCollectionFilter) return;
      root.__naokoSubCollectionFilter = new NaokoSubCollectionFilter(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
